import { getNotificationsCount, NotificationsCount } from "@/api/notifications/notificationsApi";
import { useQuery } from "@/api/useQuery";
import { EventNames } from "@/common/event-names";
import { computed, onMounted, onUnmounted, ref } from "vue";

const defaultOptions = {
    updateEnabled: true,
    updateInterval: 15000
}

export const dispatchNotificationsCount = (data: { count: number }) => {
    window.dispatchEvent(new CustomEvent<NotificationsCount>(EventNames.NotificationCounterUpdated, { detail: data }));
}

export const requestNotificationsCountUpdate = () => {
    window.dispatchEvent(new CustomEvent(EventNames.NotificationCounterUpdateRequest, {}));
}

// Таймер обновления данных о количестве уведомлений
export const useNotificationsCountUpdater = (options = defaultOptions) => {

    const { error, onOk: updated, query: update } = useQuery(getNotificationsCount);
    // some flags
    const authFailed = computed(() => error.value && error.value.status == 401);

    // dispatch counts! when updated
    updated.on((_, c) => dispatchNotificationsCount(c));

    const timerId = ref<number | null>(null);

    const routineEnter = async () => {

        await update({});

        if (authFailed.value === false) {
            timerId.value = setTimeout(routineEnter, options.updateInterval);
        }
        else {
            console.info("auth failed - stop notifications count poll");
            routineStop();
        }
    }

    const routineStop = () => {
        if (timerId.value) {
            clearTimeout(timerId.value);
        }
    }

    onMounted(() => {
        window.addEventListener(EventNames.NotificationCounterUpdateRequest, update);
        routineEnter();
    });

    onUnmounted(() => {
        window.removeEventListener(EventNames.NotificationCounterUpdateRequest, update);
        routineStop();
    });

    return {}
}